import { Box, Button, Container, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import RegistrationListActions from '../../redux/reducers/registration_list_reducer/actions';
import useStyles from './styles';
import DatatableList from './components/datatable';
import clsx from 'clsx';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import {
  TableColumns,
  Translations,
  TableDefaultFetchValues,
} from './configuration';
import NavigationConfig from '../../navigation/config';
import useQuery from 'custom_hooks/useQuery';
import ConfirmationModal from 'components/atoms/confirmation_modal';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import RegistrationDetailActions from 'redux/reducers/registration_detail_reducer/actions';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';

const RegistrationListPage = (props: any) => {
  // console.log('Render RegistrationListPage');
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const status = query.get('status');
  const state = query.get('state');
  const personal = query.get('personal');
  const goBack = query.get('goBack') === 'true' ? true : false;
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(status && { status }),
    ...(state && { state }),
    ...(personal && { personal }),
  };

  React.useEffect(() => {
    const state = getState(ReducerKeys.REGISTRATION_LIST_REDUCER)
      .registrationList.data;
    // console.log('>>>>>', state);
    dispatch(
      RegistrationListActions.fetchRegistrationListAction({
        sortField:
          state && goBack
            ? state.sorting.sortField
            : TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page:
          state && goBack
            ? state.paging.page
            : TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize:
          state && goBack
            ? state.paging.pageSize
            : TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order:
          state && goBack
            ? state.sorting.order
            : TableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    <div>
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        <Box display="flex" alignItems={'center'}>
          <AssignmentOutlinedIcon style={{ marginRight: '.75rem' }} />
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>

      <div style={{ padding: 12 }}>
        <div className={classes.cardLayout}>
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.manage_registration_title}
              defaultText={Translations.manage_registration_title.English}
            />
          </Typography>
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.manage_registration_description}
              defaultText={Translations.manage_registration_description.English}
            />
          </Typography>

          <div className={classes.tableList}>
            <div className={classes.tableHeader}>
              <Typography component={'p'} variant={'h5'}>
                <TranslatedText
                  textMap={Translations.table_title}
                  defaultText={Translations.table_title.English}
                />
              </Typography>
            </div>
            <DatatableList />
          </div>
          <div
            className={classes.dashboardButton}
            style={{ textAlign: 'right' }}
          >
            <BackToDashboardPage />
          </div>
        </div>
      </div>
      <ConfirmationModal
        modalID={ModalIDs.EXCLUDE_REGISTRATION_CONFIRM_MODAL}
        title={(params: any) => (
          <React.Fragment>
            Registration {params.rId} exclusion request
          </React.Fragment>
        )}
        body={() => (
          <React.Fragment>
            By creating an Exclusion Request, it means that you want to stop
            making use of the special schemes provided by OSS (for any reason
            applicable). Do you want to proceed?
          </React.Fragment>
        )}
        confirmButton={'YES'}
        cancelButton={'NO'}
        onClose={(response: boolean, params: any) => {
          if (response) {
            dispatch(
              RegistrationDetailActions.excludeRegistration({
                history,
                id: params.rId,
              })
            );
          }
        }}
      />
      <ConfirmationModal
        modalID={ModalIDs.UPDATE_REGISTRATION_CONFIRM_MODAL}
        title={(params: any) => (
          <React.Fragment>
            Registration {params.rId} update request
          </React.Fragment>
        )}
        body={() => (
          <React.Fragment>
            By creating an Update Request, it means that you want to amend/make
            changes to the details of your active registration. Do you want to
            proceed?
          </React.Fragment>
        )}
        confirmButton={'YES'}
        cancelButton={'NO'}
        onClose={(response: boolean, params: any) => {
          if (response) {
            dispatch(
              RegistrationDetailActions.updateRegistration({
                history,
                id: params.rId,
              })
            );
          }
        }}
      />
    </div>
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      style={{ marginTop: '1rem' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(RegistrationListPage);
